import { useState } from 'react';
import { Table, Button, Modal, Form, Container, Card } from 'react-bootstrap';
import { useGetOnboardingRequestsQuery, useSendOnboardingRequestMutation } from '../slices/onboardingApiSlice';
import Loader from '../components/Loader';
import { toast } from 'react-toastify';

const DmsScreen = () => {
  const { data: requests, isLoading, error, refetch } = useGetOnboardingRequestsQuery();
  const [sendOnboardingRequest, { isLoading: isSending }] = useSendOnboardingRequestMutation();

  const [show, setShow] = useState(false);
  const [parishName, setParishName] = useState('');
  const [email, setEmail] = useState('');

  const handleClose = () => {
    setShow(false);
    setParishName('');
    setEmail('');
  };
  const handleShow = () => setShow(true);

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      await sendOnboardingRequest({ parishName, email }).unwrap();
      toast.success('Onboarding request sent successfully');
      handleClose();
      refetch();
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  return (
    <Container fluid className="py-4 px-4 px-xl-5">
      <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: '15px' }}>
        <Card.Body className="p-4">
          <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
            <h2 className="m-0 fw-bold" style={{ color: '#2c3e50' }}>DMS Onboarding Requests</h2>
            <Button variant="primary" className="px-3 fw-semibold shadow-sm" onClick={handleShow}>
              Send New Form
            </Button>
          </div>

          {isLoading ? (
            <Loader />
          ) : error ? (
            <div className="alert alert-danger">{error?.data?.message || error.error}</div>
          ) : (
            <div className="table-responsive">
              <Table hover className="align-middle" style={{ minWidth: '1000px' }}>
                <thead className="bg-light">
                  <tr>
                    <th className="border-0">Parish Name</th>
                    <th className="border-0">Email</th>
                    <th className="border-0">Status</th>
                    <th className="border-0">Sent Date</th>
                    <th className="border-0">Opened Date</th>
                    <th className="border-0">Submitted Date</th>
                    <th className="border-0">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {requests.map((req) => (
                    <tr key={req._id}>
                      <td><span className="fw-bold text-primary">{req.parishName}</span></td>
                      <td>{req.email}</td>
                      <td>{req.status}</td>
                      <td className="text-muted">{new Date(req.sentAt).toLocaleString()}</td>
                      <td className="text-muted">{req.openedAt ? new Date(req.openedAt).toLocaleString() : 'N/A'}</td>
                      <td className="text-muted">{req.submittedAt ? new Date(req.submittedAt).toLocaleString() : 'N/A'}</td>
                      <td>
                        <div className="d-flex gap-2">
                          <Button size="sm" variant="light" className="border" href={`/onboarding/${req.token}`} target="_blank" rel="noreferrer">
                            Link
                          </Button>
                          {req.status === 'Submitted' && req.formData && (
                            <Button size="sm" variant="light" className="border" href={`/onboarding/${req.token}/pdf`} target="_blank">
                              View Form
                            </Button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                  {requests.length === 0 && (
                    <tr>
                      <td colSpan="7" className="text-center py-4 text-muted">
                        No onboarding requests found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          )}
        </Card.Body>
      </Card>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Send New Onboarding Form</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={submitHandler}>
            <Form.Group className="mb-3" controlId="parishName">
              <Form.Label>Parish Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Parish Name"
                value={parishName}
                onChange={(e) => setParishName(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className="mb-4" controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>
            <div className="d-flex justify-content-end gap-2">
              <Button variant="secondary" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="primary" type="submit" disabled={isSending}>
                {isSending ? 'Sending...' : 'Send'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default DmsScreen;
